module.exports = __webpack_public_path__ + "media/images/flag-nz-bbae570a6d018a517439e0dd9c2c5762.svg";